// @flow
import React from 'react'
import DashboardHeader from '../../../components/project_dashboard/Header/index'

type Props = {
  model: Object,
  currentAccount: Object
}

export default class DashboardHeaderContainer extends React.Component<Props> {
  componentDidMount () {
    this.props.model.on('change', function () {
      this.forceUpdate()
    }.bind(this))
  }

  render () {
    return <DashboardHeader {...this.props} />
  }
}

window.Components.DashboardHeader = React.createFactory(DashboardHeaderContainer)



// WEBPACK FOOTER //
// ./app/javascript/packs/containers/project_dashboard/Header/index.js